import  { useState } from 'react';
import { useDashboard } from '../../../context/DashboardContext';
import MessageSkeleton from '../../Skeleton/MessageSkeleton';
import { GET_SEPERATOR, IsGroupMsg } from '../../../Utils/Common';
import Message from '../../connect/chat/Message';
import { useSelector } from 'react-redux';
import CustomEditor from '../../connect/chat/CustomEditor';

const FlaggedMessages = () => {
    const { loader, pagination, prevloader, setPrevLoader, getFlaggedMsg, msgContainerRef, prevScrollHeightMsg } = useDashboard();
    const { msgs, file_drawer, active_conversation } = useSelector((state) => state.message);
    const [comingSoon, setComingSoon] = useState(false);


    const SCROLL_THRESHOLD = 400;

    let l = 0;
    const onScrollMsgs = (e) => {
        if (prevloader) return false;
        if (e.target.firstChild !== null) {
            let container = msgContainerRef.current;
            const { scrollTop, scrollHeight } = container;
            if (scrollTop > l) {
            } else {
                const THRESHOLD = SCROLL_THRESHOLD * (pagination.page > 8 ? 3 : pagination.page > 1 ? 2 : 1);
                if (scrollTop < THRESHOLD && scrollTop !== 1 && l !== 0) {
                    if (pagination.totalPages > pagination.page) {
                        prevScrollHeightMsg.current = scrollHeight;
                        setPrevLoader(true)
                        getFlaggedMsg({ variables: { conversation_id: active_conversation.conversation_id, page: pagination.page + 1 } })
                    }
                }
            }
            l = scrollTop;
        }
    }

    return (
        <>
            <div className='!h-[calc(100%-170px)]'>
                <div className='!h-full overflow-y-auto bgSurfaceDarkSec' id="main_msg_scroll_div" onScroll={onScrollMsgs} ref={msgContainerRef}>
                    {loader ?
                        (<MessageSkeleton counter={20} />)
                        : msgs.length > 0 ?
                            <>
                                {(!loader && prevloader) && <MessageSkeleton counter={20} />}
                                {msgs?.map((v, i) => (
                                    <Message
                                        key={v.msg_id}
                                        data={v}
                                        seperator={GET_SEPERATOR(msgs[i - 1], v)}
                                        is_group_msg={IsGroupMsg(msgs[i - 1], v)}
                                        file_drawer={file_drawer}
                                        type='flagged'
                                    />
                                ))}
                            </>
                            :
                            <p className="text-sm text-gray-500 text-center py-4 dark:text-white">
                                No flagged messages found.
                            </p>
                    }

                </div>
            </div>
            <CustomEditor setComingSoon={setComingSoon} flagged={true} />
        </>
    );
};

export default FlaggedMessages;